const versionDate = localStorage.getItem("fixVersion");

export const exportHTML = (fileType) => {
  const header = `<!DOCTYPE html>
                  <html lang="en">
                    <head>
                      <meta charset="UTF-8">
                      <title>Export HTML to Word Document with JavaScript</title>
                      <style>
                        body {
                          line-height: 1; /* Adjust line height as needed */
                        }
                      </style>
                    </head>
                    <body>`;
  const footer = "</body></html>";
  const sourceHTML = header + document.getElementById("source-preview-format").innerHTML + footer;

  const source = "data:application/vnd.ms-word;charset=utf-8," + encodeURIComponent(sourceHTML);
  const fileDownload = document.createElement("a");
  fileDownload.href = source;
  fileDownload.download = `release-notes-${versionDate.replace("Production", "")}.${fileType}`;
  fileDownload.style.display = "none";
  document.body.appendChild(fileDownload);
  fileDownload.click();
  document.body.removeChild(fileDownload);
};
